import styled from 'styled-components';
import Button from '../../../UI/buttons/Button';

export const ListContainer = styled.div`
  height: 100%;
  min-height: 320px;
  width: 100%;
  display: grid;
  margin-left: -2rem;
  margin-bottom: 2rem;
`;

export const EmptyText = styled.p`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #aebeca;
  padding: 5rem 0;
`;

export const JobListItem = styled.li`
  display: grid;
  grid-template-columns: minmax(230px,40%) minmax(200px,40%) 100px;
  column-gap: 1rem;
  align-items: center;
  justify-content: space-between;
  padding: 11px 0;
  border-bottom: 1px solid #dae5ec;
  position: relative;
  cursor: pointer;
`;

export const LocalJobTitle = styled.h4`
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #061c2e;
  margin: 0;
`;

export const RemoteJobTitle = styled.h4`
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #061c2e;
  margin: 0;
`;

export const JobActions = styled.div`
  display: flex;
`;

export const JobActionButton = styled(Button)`
  width: 100%;
  justify-content: center;
`;

export const DefaultMappingsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DefaultMappingsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const DefaultMappingsTitle = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin: 0;
`;

export const DefaultMappingsDescription = styled.p`
  font-size: 14px;
  color: #637381;
  margin: 0.5rem 0 0 0;
`;

export const StagesTable = styled.div`
  border: 1px solid #dae5ec;
  border-radius: 8px;
  overflow: hidden;
`;

export const StagesTableHeader = styled.div`
  display: grid;
  grid-template-columns: 40% 30% 15% 15%;
  padding: 0.75rem 1rem;
  background-color: #f7f9fb;
  border-bottom: 1px solid #dae5ec;
  font-weight: bold;
  font-size: 14px;
`;

export const StagesTableRow = styled.div`
  display: grid;
  grid-template-columns: 40% 30% 15% 15%;
  padding: 0.75rem 1rem;
  align-items: center;
  border-bottom: 1px solid #dae5ec;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const StageNameContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StageName = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

export const StageID = styled.span`
  font-size: 12px;
  color: #637381;
  margin-top: 0.25rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  gap: 1rem;
`;

export const NoStagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: #ffffff;
  border: 1px solid #dae5ec;
  border-radius: 8px;
`;

export const NoStagesText = styled.p`
  font-size: 16px;
  color: #637381;
  text-align: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;
